import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';

import { NavbarService } from './../../navbar/navbar.service';
import { LoginService } from './../../../login/login.service';
import { BaseService } from '../../../shared-service/base.service';
import { WindowRef } from '../../../shared-service/windowRef.service';

import { parse } from 'url';
import { EsignComponent } from '../../../shared-components/e-sign/esign.component';
import { filter } from 'rxjs';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.css']
})
export class AnnouncementComponent implements OnInit, OnDestroy {

  private storageLoginKey: PropertyKey = 'LoginDetails';
  private storageResourcesKey: PropertyKey = 'StringResources';
  private storageAnnouncementDetailsKey: PropertyKey = 'AnnouncementDetailsKey';
  private params: Object|any = {};
  private stringResources: Object|any = {};
  public AnnouncementDetail: Object|any = {};
  public AnnouncementItems: Array<object> = [];
  public TodayAnnouncementItems: Array<any> = [];
  public YesterdayAnnouncementItems: Array<any> = [];
  public OldAnnouncementItems: Array<any> = [];
  public AnnouncementOrderByList: Array<any> = [];
  public AnnouncementOrderBy: string="";
  public announcementSummary: Object = {};
  public EnableDetail: boolean = false;
  public EnableESign: boolean = false;
  public SelectedOrderBy: Object = {};

  @ViewChild(EsignComponent) esign!: EsignComponent;
 

  constructor(public bs: BaseService, private loginService: LoginService, private router: Router, private navbarService: NavbarService ,private winRef: WindowRef) {
    this.bs.log('info', "Loaded AnnouncementComponent");
    this.stringResources = JSON.parse(this.navbarService.getStoreData(this.storageResourcesKey));

    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e: NavigationEnd|any) => {      
      if (this.esign.IsEsignPopupOpen()) {
        this.esign.closePanel();
      }
    });
  };

  ngOnInit() {
    this.bs.log('info', "ngOnInit AnnouncementComponent");
    this.EnableESign = this.bs.getUserAttr("EnableESign");
    this.AnnouncementOrderBy = this.stringResources['rbkey_RcntLBL_App'];
    this.SelectedOrderBy= 
      {
        action: "RECENT",
        name: this.stringResources['rbkey_RcntLBL_App']
      };
    
    this.AnnouncementOrderByList = [
      {
        action: "RECENT",
        name: this.stringResources['rbkey_RcntLBL_App']
      },
      {
        action: "READ",
        name: this.stringResources['rbkey_RdLBL']
      },
      {
        action: "UNREAD",
        name: this.stringResources['rbkey_UnrdLBL']
      }
    ];

    if (this.EnableESign) {
      this.AnnouncementOrderByList.push({
        action: "UNACKNOWLEDGED",
        name: this.stringResources['rbkey_UnAcknwldgLbl']
      });
    }
    this.RefreshList();
  }

  ngOnDestroy() {
    this.esign.closePanel();
  }

  orderBy(OrderBy:any) {
    this.bs.log('info', OrderBy);
    let action = OrderBy.action;
    this.params['OrderBy'] = action;
    this.params['AnnoncementId'] = null;
    this.params['PageNumber'] = 1;
    this.params['PageSize'] = 10;
    this.AnnouncementOrderBy = OrderBy.name;
    this.SelectedOrderBy = OrderBy;
    this.getList();
    return false;
  };

  getList() {
    this.navbarService.getPublicAnnouncementFromServer(this.params, this.storageAnnouncementDetailsKey).then((data:any) => {
      this.AnnouncementDetail = data;
      this.AnnouncementItems = this.AnnouncementDetail['AnnouncementItems'];
      this.updateLists(this.AnnouncementItems);
      this.bs.UnreadAnnouncementCount = this.AnnouncementDetail['TotalUnreadRecords'];
    }, (data) => {
      this.bs.log('error', 'Error in getting list');
    });
  };

  updateLists(aList: Array<object>|any) {
    this.TodayAnnouncementItems = [];
    this.YesterdayAnnouncementItems = [];
    this.OldAnnouncementItems = [];
    let noOfAnnouncement = aList.length;
    if (noOfAnnouncement == 0) {

      return;
    }
    for (let i = 0; i < noOfAnnouncement; i++) {
      let nDate = aList[i]['CreationDate'];
      nDate = nDate.slice(0, 10);
      let days = this.dateDiffInDays(new Date(), new Date(nDate));
      if (days == 0) {
        this.TodayAnnouncementItems.push(aList[i]);
      } else if (days == 1) {
        this.YesterdayAnnouncementItems.push(aList[i]);
      } else {
        this.OldAnnouncementItems.push(aList[i]);
      }
    }
  }


  dateDiffInDays(a:any, b:any) {
    let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
  }

  todayDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var today1;
    var dd1 = String(today.getDate());
    var mm1 = String(today.getMonth() + 1);
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd1 = '0' + dd;
    }
    if (mm < 10) {
      mm1 = '0' + mm;
    }
    today1 = dd1 + '/' + mm1 + '/' + yyyy;
    return today1;
  }
  setTodayClassName(index: any) {
    if (this.TodayAnnouncementItems[index]['IsRead']) {
      return "announcement-tab-list-box active";
    }
    else {
      return "announcement-tab-list-box";
    }
  }

  setOldClassName(index: any) {
    if (this.OldAnnouncementItems[index]['IsRead']) {
      return "announcement-tab-list-box active";
    }
    else {
      return "announcement-tab-list-box";
    }
  }

  setYesterdayClassName(index: any) {
    if (this.YesterdayAnnouncementItems[index]['IsRead']) {
      return "announcement-tab-list-box active";
    }
    else {
      return "announcement-tab-list-box";
    }
  }

  OpenAnnouncement(Announcement: Object) {
    this.EnableDetail = true;
    this.bs.log('info', "Enterning OpenAnnouncement");
    this.announcementSummary = Announcement;
    this.EnableDetail = true;
    setTimeout(() => {
      var announcementDetailId:any = this.winRef.nativeWindow.document.getElementById("announcementDetail");
      announcementDetailId.className = announcementDetailId.className + " show";

    }, 50)
  }

  announcementTitle(object: any) {
    let title = object;
    return this.trunc(50, title);

  }

  announcementDescription(object: any) {
    let description = object;
    return this.trunc(100, description);

  }

  enableMore(object: any) {
    if (object['Title'].length > 50 || object['Description'].length > 100) {
      return true;
    }
    else {
      return false;
    }
  }

  trunc(n:any, useWordBoundary:any) {
    if (useWordBoundary <= n) { return useWordBoundary; }
    var subString = useWordBoundary.substring(0, n - 1);
    return (useWordBoundary
      ? subString.substring(0, subString.lastIndexOf(' '))
      : subString) + "...";
  };

  navigateListPage() {
    //inactive all menus
    this.bs.deActivateAllMenus();

    let bodyTag = $('body');
    bodyTag.removeClass('offsidebar-open');
    this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
    this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow switch learning-la";
    this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_SystmNtfctnLBL');
    this.router.navigate(['/learner/system-alert/announcement', { IsAnnouncement: true, RefreshParam: new Date }]);


  }



  readAnnouncement(AnnoncementId: any, IsRead: boolean, IsAcknowledgementRequired: boolean) {
    if (!IsRead) {
      if (!this.EnableESign)
        this.SetAnnouncementRead(AnnoncementId);
      else if (IsAcknowledgementRequired)
        this.esign.openModelPopup(AnnoncementId,true);
      else
        this.SetAnnouncementRead(AnnoncementId);
    }
  }

  SetAnnouncementRead(AnnoncementId: any) {
    this.params = {
      'AnnoncementId': AnnoncementId,
    };
    this.navbarService.setPublicAnnouncementReadFromServer(this.params, this.storageAnnouncementDetailsKey).then((data) => {
      if (data == "T") {
        this.bs.announcementCount = this.bs.announcementCount - 1;
        $("#announcementDiv" + AnnoncementId).addClass("active");
        this.AnnouncementDetail['TotalUnreadRecords'] = this.AnnouncementDetail['TotalUnreadRecords'] - 1;
        let unreadCount = parseInt(this.AnnouncementDetail['TotalUnreadRecords']);
        this.bs.UnreadAnnouncementCount = unreadCount;
      }
    },
      (data) => {
        this.bs.log('error', 'Error in getting list');
      });
  }
  AcknowledgeEsign(eventObj:any) {
    let announcementId: any = eventObj;
    this.SetAnnouncementRead(announcementId);
    this.esign.closePanel();
    this.orderBy(this.SelectedOrderBy);
  }

  RefreshList() {
    this.params = {
      'OrderBy': "RECENT",
    };
    this.navbarService.setObservableValue({ "EnableNotification": false });
    this.navbarService.currentValue.subscribe(
      (result:any) => {
        this.getList();
      });
  }
}
